/* eslint-disable import/no-mutable-exports */
/* eslint-disable global-require */

let history;

if (typeof document !== 'undefined') {
  const { createMemoryHistory } = require('history');

  history = createMemoryHistory();
}

export default history;
